'use client'
import { assertPackageVersion } from '@dynamic-labs/assert-package-version';
import { version } from '../package.js';
import { ZeroDevConnector } from './ZeroDevConnector.js';
import { ZKsyncConnector } from './ZKsyncConnector.js';
export { createEcdsaKernelAccountClient } from './utils/createEcdsaKernelAccountClient.js';
export { fetchZeroDevChain } from './utils/fetchZeroDevChain.js';
export { getEcdsaValidator } from './utils/getEcdsaValidator.js';
export { getEntryPoint } from './utils/getEntryPoint.js';
export { getKernelVersion } from './utils/getKernelVersion.js';
export { EthereumAaConnector } from './ethereum-aa.js';
export { isZeroDevConnector } from './utils/isZeroDevConnector.js';
export { isZKsyncConnector } from './utils/isZKsyncConnector.js';

assertPackageVersion('@dynamic-labs/ethereum-aa', version);
const ZeroDevSmartWalletConnectorsWithConfig = ({ bundlerProvider, bundlerRpc, paymasterRpc, kernelDelegationAddress, } = {}) => {
    ZeroDevConnector.bundlerProvider = bundlerProvider;
    ZeroDevConnector.bundlerRpc = bundlerRpc;
    ZeroDevConnector.paymasterRpc = paymasterRpc;
    ZeroDevConnector.kernelDelegationAddress = kernelDelegationAddress;
    return ZeroDevSmartWalletConnectors;
};
const ZeroDevSmartWalletConnectors = (props) => {
    var _a;
    if ((_a = props.apiProviders) === null || _a === void 0 ? void 0 : _a.zerodev) {
        return [ZeroDevConnector];
    }
    return [];
};
const ZKsyncSmartWalletConnectors = (props) => {
    var _a;
    if ((_a = props.apiProviders) === null || _a === void 0 ? void 0 : _a.zksync) {
        return [ZKsyncConnector];
    }
    return [];
};

export { ZKsyncSmartWalletConnectors, ZeroDevSmartWalletConnectors, ZeroDevSmartWalletConnectorsWithConfig };
